export const checkFieldUpdate = (fieldList, existingObj) => {
  console.log("fieldList: ", fieldList);
  console.log("existingObj: ", existingObj);
  let updatedObj = {};
  console.log(fieldList);
  fieldList.forEach((field) => {
    console.log("field: ", field, "current field: ", existingObj[field.name]);
    if (field.val !== existingObj[field.name]) {
      console.log("doesn't match", field.val, existingObj[field.name]);
      updatedObj[field.name] = field.val;
    }
  });
  return updatedObj;
};

export function setXClientHost() {
  return window.location.origin === "http://localhost:3000"
    ? process.env.REACT_APP_LOCAL_URL
    : window.location.origin;
}

export function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = "";
  }
  var pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  url = url.replace(/[?#]$/, "");
  return url + "&" + paramName + "=" + paramValue;
  // return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}

export function buildOrderDateRange(dateBefore, dateAfter) {
  if (dateBefore && dateAfter) {
    return `${dateAfter.toISOString().slice(0, 10)},${dateBefore
        .toISOString()
        .slice(0, 10)}`;
  }

  if (dateBefore && !dateAfter) {
    return `lte,${dateBefore.toISOString().slice(0, 10)}`;
  }

  if (!dateBefore && dateAfter) {
    return `gte,${dateAfter.toISOString().slice(0, 10)}`;
  }

  return "";
}
